/**
 * internal dependencies
 */
import { showToast } from "../toasts";
import { getCardGroupListData } from "./data/get-cardgroup";
import { displayCardGroupTable } from "./display/display-cardgroup";
import { cardGroupTableFilter } from "./filters/cardgroup-filter";

/**
 * Card Group Table Main
 * This function initializes and manages the card group table and related functionalities.
 * 
 * @returns void
 */
const CardGroupTable = async (): Promise<void> => {
  const cardGroupTable = document.querySelector('.aafp_card-group-list') as HTMLElement;
  if(!cardGroupTable) return;

  const cardGroupData = await getCardGroupListData();

  if (cardGroupData.length === 0) {
    showToast("aafp_toast-alert", "Error fetching card group data. Please try again later.");
    return;
  }

  const tableObject = displayCardGroupTable(cardGroupTable, cardGroupData);
  cardGroupTableFilter(tableObject);
};

export default CardGroupTable;